
import ColumnSlot from './ColumnSlot';

export default {
    props: {
        columns: {
            type: null,
            default: null
        },
        rows: {
            type: null,
            default: null
        }
    },
    components: {
        'DTColumnSlot': ColumnSlot
    }
}
